import { useWeb3React } from "@web3-react/core";

function Status(){
    const {active} = useWeb3React();

    return(
            <div className="absolute top-4 right-4 w-40">
                <h1 className="text-white font-thin">Connected: {active ? <span className="text-green-400 font-bold">True</span>:<span className="text-red-600 font-bold">False</span>}</h1>
            </div>
    )
}

export default Status;